import { ApiProperty } from '@nestjs/swagger'
import { Length } from 'class-validator'
import { IsString } from 'class-validator'
import { IsNotEmpty } from 'class-validator'
import { IBillingSettings } from '@backend/domain'

export class BillingSettings implements IBillingSettings {
	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	@Length(3, 3)
	currencyCode: string
}
